

export function MedicationsView({ appContext }) {
    return <span>Medications View</span>
}